import type {
    CommerceOperationOptions,
    CommerceStorefrontExperience,
    ResolveCommerceStorefrontRequest,
} from "@teqtank/commerce-contracts";
import { CommerceRepository } from "../repositories/commerce-repository.js";
import { resolveCommerceStorefrontOperation } from "../operations/resolve-commerce-storefront-operation.js";
import { clearCommerceStorefrontOperation } from "../operations/clear-commerce-storefront-operation.js";
export class CommerceStorefrontRepository extends CommerceRepository {
    public async resolve(
        request: ResolveCommerceStorefrontRequest,
        options: CommerceOperationOptions,
    ): Promise<CommerceStorefrontExperience> {
        return (
            await this.execute(
                resolveCommerceStorefrontOperation,
                request,
                options,
                "storefront-operation-failed",
                "Teqtank Commerce could not resolve the personal storefront.",
            )
        ).storefront;
    }

    public async clear(options: CommerceOperationOptions): Promise<CommerceStorefrontExperience> {
        return (
            await this.execute(
                clearCommerceStorefrontOperation,
                {},
                options,
                "storefront-operation-failed",
                "Teqtank Commerce could not exit the representative storefront.",
            )
        ).storefront;
    }
}
